'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var Bone = require('../bone');
var AbstractDriver = require('../drivers/abstract');
var camelCase = require('../utils/string').camelCase;
var isBone = require('../utils').isBone;
var sequelize = require('../adapters/sequelize');
var Raw = require('../raw').default;
var LEGACY_TIMESTAMP_MAP = require('../constants').LEGACY_TIMESTAMP_MAP;
var SequelizeBone = sequelize(Bone);
/**
 *
 * @typedef {Object} QueryResult
 * @property {Array} rows
 * @property {Array} fields
 */
/**
 * construct model attributes entirely from column definitions
 * @param {Bone} model
 * @param {Array<string, Object>} columns column definitions
 */
function initAttributes(model, columns) {
    var e_1, _a;
    var attributes = {};
    try {
        for (var columns_1 = __values(columns), columns_1_1 = columns_1.next(); !columns_1_1.done; columns_1_1 = columns_1.next()) {
            var columnInfo = columns_1_1.value;
            var columnName = columnInfo.columnName, columnType = columnInfo.columnType, restInfo = __rest(columnInfo, ["columnName", "columnType"]);
            var name_1 = columnName === '_id' ? columnName : camelCase(columnName);
            attributes[name_1] = __assign(__assign({}, restInfo), { columnName: columnName, type: model.driver.DataTypes.findType(columnType) });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (columns_1_1 && !columns_1_1.done && (_a = columns_1.return)) _a.call(columns_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    for (var name_2 in LEGACY_TIMESTAMP_MAP) {
        var newName = LEGACY_TIMESTAMP_MAP[name_2];
        if (attributes.hasOwnProperty(name_2) && !attributes.hasOwnProperty(newName)) {
            attributes[newName] = attributes[name_2];
            delete attributes[name_2];
        }
    }
    model.init(attributes, { timestamps: false });
}
function loadModels(Spine, models, opts) {
    return __awaiter(this, void 0, void 0, function () {
        var database, tables, schemaInfo, models_1, models_1_1, model, columns, models_2, models_2_1, model;
        var e_2, _a, e_3, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    database = opts.database;
                    tables = models.map(function (model) { return model.physicTable; });
                    return [4 /*yield*/, Spine.driver.querySchemaInfo(database, tables)];
                case 1:
                    schemaInfo = _c.sent();
                    try {
                        for (models_1 = __values(models), models_1_1 = models_1.next(); !models_1_1.done; models_1_1 = models_1.next()) {
                            model = models_1_1.value;
                            // assign driver if model's driver not exist
                            if (!model.driver)
                                model.driver = Spine.driver;
                            // assign options if model's options not exist
                            if (!model.options)
                                model.options = Spine.options;
                            columns = schemaInfo[model.physicTable] || schemaInfo[model.table];
                            if (!model.attributes)
                                initAttributes(model, columns);
                            model.load(columns);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (models_1_1 && !models_1_1.done && (_a = models_1.return)) _a.call(models_1);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    try {
                        for (models_2 = __values(models), models_2_1 = models_2.next(); !models_2_1.done; models_2_1 = models_2.next()) {
                            model = models_2_1.value;
                            model.initialize();
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (models_2_1 && !models_2_1.done && (_b = models_2.return)) _b.call(models_2);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function createSpine(opts) {
    var Model = Bone;
    if (opts.Bone && opts.Bone.prototype instanceof Bone) {
        Model = opts.Bone;
    }
    else if (opts.sequelize) {
        Model = SequelizeBone;
    }
    return opts.subclass === true ? /** @class */ (function (_super) {
        __extends(Spine, _super);
        function Spine() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return Spine;
    }(Model)) : Model;
}
var rReplacementKey = /\s:(\w+)\b/g;
var BaseRealm = /** @class */ (function () {
    function BaseRealm(opts) {
        var e_4, _a;
        if (opts === void 0) { opts = {}; }
        var _b = opts.dialect, dialect = _b === void 0 ? 'mysql' : _b, dialectModulePath = opts.dialectModulePath, _c = opts.client, client = _c === void 0 ? dialectModulePath : _c, _d = opts.database, database = _d === void 0 ? opts.db || opts.storage : _d, CustomDriver = opts.driver, restOpts = __rest(opts, ["dialect", "dialectModulePath", "client", "database", "driver"]);
        var Spine = createSpine(opts);
        var models = {};
        if (Array.isArray(opts.models)) {
            try {
                for (var _e = __values(opts.models), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var model = _f.value;
                    models[model.name] = model;
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        var DriverClass = this.getDriverClass(CustomDriver, dialect);
        var driver = new DriverClass(__assign({ client: client, database: database }, restOpts));
        var options = __assign(__assign({ client: client, dialect: driver.dialect, database: database, driver: DriverClass }, restOpts), { define: __assign({ underscored: true }, opts.define) });
        this.Bone = Spine;
        this.models = Spine.models = models;
        this.driver = Spine.driver = driver;
        this.options = Spine.options = options;
    }
    BaseRealm.prototype.getDriverClass = function (CustomDriver, dialect) {
        if (CustomDriver && CustomDriver.prototype instanceof AbstractDriver) {
            return CustomDriver;
        }
        throw new Error('DriverClass must be a subclass of AbstractDriver');
    };
    BaseRealm.prototype.define = function (name, attributes, opts, descriptors) {
        var _a;
        if (opts === void 0) { opts = {}; }
        if (descriptors === void 0) { descriptors = {}; }
        var Model = (_a = /** @class */ (function (_super) {
                __extends(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return class_1;
            }(this.Bone)),
            _a.name = name,
            _a);
        Model.init(attributes, opts, descriptors);
        this.Bone.models[name] = Model;
        return Model;
    };
    BaseRealm.prototype.getModels = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Object.values(this.models)];
            });
        });
    };
    BaseRealm.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var models, models_3, models_3_1, model;
            var e_5, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getModels()];
                    case 1:
                        models = _b.sent();
                        try {
                            for (models_3 = __values(models), models_3_1 = models_3.next(); !models_3_1.done; models_3_1 = models_3.next()) {
                                model = models_3_1.value;
                                this.Bone.models[model.name] = model;
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (models_3_1 && !models_3_1.done && (_a = models_3.return)) _a.call(models_3);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        // models could be connected already if cached
                        models = models.filter(function (model) { return model.synchronized == null; });
                        if (!(models.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, loadModels(this.Bone, models, this.options)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        this.connected = true;
                        return [2 /*return*/, this.Bone];
                }
            });
        });
    };
    BaseRealm.prototype.disconnect = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.connected && this.driver)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.driver.disconnect(callback)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BaseRealm.prototype.sync = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var models, _a, _b, model, e_6_1;
            var e_6, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!!this.connected) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.connect()];
                    case 1:
                        _d.sent();
                        _d.label = 2;
                    case 2:
                        models = this.models;
                        _d.label = 3;
                    case 3:
                        _d.trys.push([3, 8, 9, 10]);
                        _a = __values(Object.values(models)), _b = _a.next();
                        _d.label = 4;
                    case 4:
                        if (!!_b.done) return [3 /*break*/, 7];
                        model = _b.value;
                        return [4 /*yield*/, model.sync(options)];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6:
                        _b = _a.next();
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_6_1 = _d.sent();
                        e_6 = { error: e_6_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_6) throw e_6.error; }
                        return [7 /*endfinally*/];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * raw query
     * @param {string} query
     * @param {Array<any>} values
     * @param {Connection} opts.connection specific connection of this query, may used in a transaction
     * @param {Bone} opts.model target model to inject values
     * @returns {QueryResult}
     * @memberof Realm
     */
    BaseRealm.prototype.query = function (query, values, opts) {
        if (opts === void 0) { opts = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var model, connection, replacements, _a, rows, restRes, results, attributeMap, rows_1, rows_1_1, data, instance, key;
            var e_7, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (values && typeof values === 'object' && !Array.isArray(values)) {
                            if ('replacements' in values) {
                                model = values.model, connection = values.connection;
                                opts.replacements = values.replacements;
                                if (model)
                                    opts.model = model;
                                if (connection)
                                    opts.connection = connection;
                            }
                            else {
                                opts.replacements = values;
                            }
                            values = [];
                        }
                        replacements = opts.replacements || {};
                        query = query.replace(rReplacementKey, function replacer(m, key) {
                            if (!replacements.hasOwnProperty(key)) {
                                throw new Error("unable to replace: ".concat(key));
                            }
                            values.push(replacements[key]);
                            return ' ?';
                        });
                        return [4 /*yield*/, this.driver.query(query, values, opts)];
                    case 1:
                        _a = _c.sent(), rows = _a.rows, restRes = __rest(_a, ["rows"]);
                        results = [];
                        if (rows && rows.length && opts.model && isBone(opts.model)) {
                            attributeMap = opts.model.attributeMap;
                            try {
                                for (rows_1 = __values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
                                    data = rows_1_1.value;
                                    instance = opts.model.instantiate(data);
                                    for (key in data) {
                                        if (!attributeMap.hasOwnProperty(key))
                                            instance[key] = data[key];
                                    }
                                    results.push(instance);
                                }
                            }
                            catch (e_7_1) { e_7 = { error: e_7_1 }; }
                            finally {
                                try {
                                    if (rows_1_1 && !rows_1_1.done && (_b = rows_1.return)) _b.call(rows_1);
                                }
                                finally { if (e_7) throw e_7.error; }
                            }
                        }
                        return [2 /*return*/, __assign(__assign({}, restRes), { rows: results.length > 0 ? results : rows })];
                }
            });
        });
    };
    BaseRealm.prototype.transaction = function (callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.Bone.transaction(callback)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * raw sql object
     * @static
     * @param {string} sql
     * @returns {RawSql}
     * @memberof Realm
     */
    BaseRealm.raw = function (sql) {
        if (typeof sql !== 'string') {
            throw new TypeError('sql must be a string');
        }
        return new Raw(sql);
    };
    // instance.raw
    BaseRealm.prototype.raw = function (sql) {
        return BaseRealm.raw(sql);
    };
    /**
     * escape value
     * @param {string} value
     * @returns {string} escaped value
     * @memberof Realm
     */
    BaseRealm.prototype.escape = function (value) {
        return this.driver.escape(value);
    };
    BaseRealm.SequelizeBone = SequelizeBone;
    return BaseRealm;
}());
module.exports = BaseRealm;
//# sourceMappingURL=base.js.map